/*
 * Copyright (c) 2019 - Bas Milius <bas@mili.us>
 *
 * This file is part of the Latte UI package.
 *
 * For the full copyright and license information, please view the
 * LICENSE file that was distributed with this source code.
 */

import clipboard from "./clipboard";
import cookies from "./cookies";
import datetime from "./datetime";
import dom from "./dom";
import json from "./json";
import object from "./object";
import string from "./string";
import touch from "./touch";

export default {
	clipboard,
	cookies,
	datetime,
	dom,
	json,
	object,
	string,
	touch
};
